import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {AnnexReject} from '../../../../models/api/annex-reject.model';

@Component({
    selector: 'app-annex-reject',
    templateUrl: './annex-reject.component.html',
    standalone: false,
})
export class AnnexRejectComponent implements OnInit {
    public form: UntypedFormGroup;

    constructor(private fb: UntypedFormBuilder) {}

    get annexRejectModel(): AnnexReject {
        return new AnnexReject(this.form.getRawValue());
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            uwrComment: [''],
        });
    }
}
